import { useField } from 'formik'
import { TextField } from '@mui/material'

const FormTextField = ({
  'data-testid': testId,
  label,
  placeholder,
  ...props
}) => {
  const [field, meta] = useField(props)
  return (
    <TextField
      placeholder={placeholder}
      label={label}
      {...field}
      {...props}
      inputProps={{ 'data-testid': testId }}
      error={meta.touched && !!meta.error}
      helperText={meta.touched && meta.error}
      margin={props.margin || 'normal'}
    />
  )
}

export default FormTextField
